import { createFileRoute } from '@tanstack/react-router';
import { CourseEditorPage } from '@/app/courses/CourseEditorPage';
import { courseByIdQuery } from '@/modules/catalog/public';
import { RequirePermission } from '@/modules/identity/public';

export const Route = createFileRoute('/_admin/cursos/$courseId')({
  loader: ({ context, params }) => context.queryClient.prefetchQuery(courseByIdQuery(params.courseId)),
  component: function CourseEditorRoute() {
    const { courseId } = Route.useParams();
    return (
      <RequirePermission anyOf={['cursos.ver']}>
        <CourseEditorPage courseId={courseId} />
      </RequirePermission>
    );
  },
});
